import * as XLSX from 'xlsx';

export async function getFormListsFromExcel(url) {
  const response = await fetch(url);
  if (!response.ok) throw new Error('No se pudo descargar el archivo Excel');
  const blob = await response.blob();
  const data = await blob.arrayBuffer();
  const workbook = XLSX.read(data, { type: 'array' });
  const sheet = workbook.Sheets['formulario_soporte'] || workbook.Sheets[workbook.SheetNames[0]];
  const tables = workbook.Workbook?.Names || [];

  let solicitantes = [], sedes = [], campanias = [];
  let tiposIncidente = [], responsablesSolucion = [];

  tables.forEach(tbl => {
    console.log(`Tabla encontrada: ${tbl.Name}, Ref: ${tbl.Ref}`);
  });

  // Buscar por tablas
  tables.forEach(tbl => {
    const ref = tbl.Ref;
    const range = XLSX.utils.decode_range(ref);

    function extractValues() {
      const values = [];
      for (let R = range.s.r; R <= range.e.r; ++R) {
        const cell = sheet[XLSX.utils.encode_cell({ r: R, c: range.s.c })];
        if (cell && cell.v) values.push(cell.v);
      }
      return values;
    }

    switch (tbl.Name) {
      case 'solicitante':
        solicitantes = extractValues();
        break;
      case 'sede':
        sedes = extractValues();
        break;
      case 'campanna':
        campanias = extractValues();
        break;
      case 'tipoincidente':
        tiposIncidente = extractValues();
        break;
      case 'responsablesolucion':
        responsablesSolucion = extractValues();
        break;
    }
  });

  // Si no se encontraron datos por tablas, buscar por encabezados de columna
  if (
    solicitantes.length === 0 ||
    sedes.length === 0 ||
    campanias.length === 0 ||
    tiposIncidente.length === 0 ||
    responsablesSolucion.length === 0
  ) {
    const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
    const headerRow = jsonData[0] || [];

    const idxSolicitante = headerRow.findIndex(h => h?.toLowerCase().includes('solicitante'));
    const idxSede = headerRow.findIndex(h => h?.toLowerCase().includes('sede'));
    const idxCampania = headerRow.findIndex(h => h?.toLowerCase().includes('campaña'));
    const idxTipoIncidente = headerRow.findIndex(h => h?.toLowerCase().includes('tipo') && h?.toLowerCase().includes('incidente'));
    const idxResponsableSolucion = headerRow.findIndex(h => h?.toLowerCase().includes('responsable') && h?.toLowerCase().includes('solución'));

    for (let i = 1; i < jsonData.length; i++) {
      const row = jsonData[i];
      if (idxSolicitante !== -1 && row[idxSolicitante]) solicitantes.push(row[idxSolicitante]);
      if (idxSede !== -1 && row[idxSede]) sedes.push(row[idxSede]);
      if (idxCampania !== -1 && row[idxCampania]) campanias.push(row[idxCampania]);
      if (idxTipoIncidente !== -1 && row[idxTipoIncidente]) tiposIncidente.push(row[idxTipoIncidente]);
      if (idxResponsableSolucion !== -1 && row[idxResponsableSolucion]) responsablesSolucion.push(row[idxResponsableSolucion]);
    }
  }

  return {
    solicitantes,
    sedes,
    campanias,
    tiposIncidente,
    responsablesSolucion
  };
}
